<template>
    <v-app>
        <v-dialog v-model="dialogAddParcel" persistent scrollable max-width="450">
          <v-card class="elevation-5">
            <v-toolbar dark color="primary">
              <v-toolbar-title>
                {{$t('register_parcel')}}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                  class="align-self-end"
                  color="red"
                  icon
                  @click="dialogAddParcel = false"
              ><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-autocomplete
                      class="mt-5"
                      v-model="idHouse"
                      prepend-icon="mdi-home-city"
                      name="idHouse"
                      :item-text="example"
                      item-value="id"
                      :label="$t('direccion')"
                      :placeholder="$t('search_by_house_number')"
                      :filter="customFilterHouse"
                      :items="houses"
                      :error-messages="errores.idHouse"
                      no-data-text="Ningún Resultado"
                      clearable
                      outlined
                      autocomplete="off"
                      @change="fillResidents"
                  >
                    <template v-slot:item="data">
                      <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}}</strong>
                    </template>
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <v-combobox
                      v-model="addressee"
                      name="addressee"
                      clearable
                      outlined
                      prepend-icon="mdi-account"
                      item-text="fullname"
                      item-value="fullname"
                      @change="onChangeComboBoxResidents"
                      :label="$t('addressee')"
                      :items="residents"
                      autocomplete="off"
                      :error-messages="errores.addressee"
                  ></v-combobox>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                      v-model="guide_number"
                      name="guide_number"
                      outlined
                      prepend-icon="mdi-numeric-1-box"
                      :label="$t('guide_number')"
                      :error-messages="errores.tracking_number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete
                      v-model="idParcelCompany"
                      prepend-icon="mdi-truck"
                      name="idParcelCompany"
                      :item-text="textParcelCompany"
                      item-value="id"
                      :label="$t('company')"
                      :placeholder="$t('search_by_name')"
                      :filter="customFilterParcelCompany"
                      :items="parcel_companies"
                      no-data-text="Ningún Resultado"
                      :error-messages="errores.idParcelCompany"
                      clearable
                      outlined
                      autocomplete="off"
                  >
                    <template v-slot:item="data">
                      <strong>{{data.item.name === null ? 'n/a' : data.item.name}}</strong>
                    </template>
                  </v-autocomplete>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" @click="dialogAddParcel = false">{{$t('cerrar')}}</v-btn>
              <v-spacer/>
              <v-btn :disabled="(addressee === null || addressee === undefined)" :loading="loading" @click="addParcel" color="primary">{{$t('register')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogUpdateWaterService" persistent scrollable max-width="450">
          <v-card class="elevation-5">
            <v-toolbar dark color="primary">
              <v-toolbar-title>
                {{$t('water_service_delivery')}}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                  class="align-self-end"
                  color="red"
                  icon
                  @click="dialogUpdateWaterService = false"
              ><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-combobox
                      class="mt-5"
                      v-model="vigilant_name_water_service"
                      name="vigilant_name_water_service"
                      outlined
                      clearable
                      prepend-icon="mdi-account-tie-hat"
                      item-text="fullname"
                      item-value="fullname"
                      @change="onChangeComboBoxVigilantsWaterService"
                      :label="$t('who_delivered')"
                      :items="vigilants"
                      autocomplete="off"
                      :error-messages="errores.vigilant_name"
                  ></v-combobox>
                </v-flex>
                <v-flex xs12>
                  <v-data-table
                      :headers="headersWaterService"
                      show-select
                      v-model="selectedWaterServices"
                      :hide-default-footer="true"
                      :items="waterServices"
                      :footer-props="{
                                        itemsPerPageOptions: [
                                            {text: '5', value: 5},
                                            {text: '10', value: 10},
                                            {text: '25', value: 25},
                                            {text: this.$t('todos'), value: -1}
                                        ],
                                        itemsPerPageText: $t('filas_por_pagina')
                                    }"
                      :no-data-text="$t('no_records_yet')"
                      class="elevation-1"
                  >
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" @click="dialogUpdateWaterService = false">{{$t('cerrar')}}</v-btn>
              <v-spacer/>
              <v-btn
                  :disabled="selectedWaterServices.length === 0 || (vigilant_name_water_service === null || vigilant_name_water_service === undefined || vigilant_name_water_service === '')"
                  :loading="loading"
                  @click="waterServiceDelivery()"
                  color="primary">
                {{$t('guardar')}}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogUpdateParcel" persistent scrollable max-width="450">
          <v-card class="elevation-5">
            <v-toolbar dark color="primary">
              <v-toolbar-title>
                {{$t('package_delivery')}}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                  class="align-self-end"
                  color="red"
                  icon
                  @click="dialogUpdateParcel = false"
              ><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-combobox
                      class="mt-5"
                      v-model="vigilant_name"
                      name="vigilant_name"
                      outlined
                      clearable
                      prepend-icon="mdi-account-tie-hat"
                      item-text="fullname"
                      item-value="fullname"
                      @change="onChangeComboBoxVigilants"
                      :label="$t('who_delivered')"
                      :items="vigilants"
                      autocomplete="off"
                      :error-messages="errores.vigilant_name"
                  ></v-combobox>
                </v-flex>
                <v-flex xs12>
                  <v-combobox
                      v-model="resident_name"
                      name="resident_name"
                      outlined
                      clearable
                      prepend-icon="mdi-account"
                      item-text="fullname"
                      item-value="fullname"
                      @change="onChangeComboBoxResidents"
                      :label="$t('who_received')"
                      :items="residents"
                      autocomplete="off"
                      :error-messages="errores.resident_name"
                  ></v-combobox>
                </v-flex>
                <v-flex xs12>
                  <v-data-table
                      :headers="headersPackage"
                      show-select
                      v-model="selected"
                      :hide-default-footer="true"
                      :items="packagesByHouse"
                      :footer-props="{
                                        itemsPerPageOptions: [
                                            {text: '5', value: 5},
                                            {text: '10', value: 10},
                                            {text: '25', value: 25},
                                            {text: this.$t('todos'), value: -1}
                                        ],
                                        itemsPerPageText: $t('filas_por_pagina')
                                    }"
                      :no-data-text="$t('no_records_yet')"
                      class="elevation-1"
                  >
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" @click="dialogUpdateParcel = false">{{$t('cerrar')}}</v-btn>
              <v-spacer/>
              <v-btn
                  :disabled="selected.length === 0 || (vigilant_name === null || vigilant_name === undefined || vigilant_name === '') || (resident_name === null || resident_name === undefined || resident_name === '')"
                  :loading="loading"
                  @click="packageDelivery()"
                  color="primary">
                {{$t('guardar')}}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <Snackbar></Snackbar>
        <DialogShow></DialogShow>
        <v-navigation-drawer
                v-model="drawer"
                v-if="isAuthenticated && otpReady"
                :clipped="$vuetify.breakpoint.lgAndUp"
                app
                expand-on-hover
                color="primary"
                :src="getProfile.wallpaper"
        >
            <template v-slot:img="props">
                <v-img
                        v-bind="props"
                        gradient="to bottom left, rgba(19,84,122,.5), rgba(128,208,199,.8)"
                ></v-img>
            </template>
            <v-list dense>
                <v-list>
                    <v-list-item>
                        <v-list-item-avatar size="75">
                            <v-img :src="getProfile.avatar"/>
                        </v-list-item-avatar>
                    </v-list-item>
                    <v-list-item
                            link
                            three-line
                    >
                        <v-list-item-content>
                            <v-list-item-title class="text--white">{{getProfile.role == 0 ? $t('SuperAdministrador') : ""}}</v-list-item-title>
                            <v-list-item-title class="text--white">{{getProfile.role == 1 ? $t('Administrador') : ""}}</v-list-item-title>
                            <v-list-item-title class="text--white">{{getProfile.role == 2 ? $t('residente_principal') : ""}}</v-list-item-title>
                            <v-list-item-title class="text--white">{{getProfile.role == 3 ? $t('residente') : ""}}</v-list-item-title>
                            <v-list-item-title class="text--white">{{getProfile.role == 4 ? $t('Vigilante') : ""}}</v-list-item-title>
                            <v-list-item-title class="title">{{getProfile.first_name}} {{getProfile.last_name}}</v-list-item-title>
                            <v-list-item-subtitle>{{getProfile.email}}</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-icon>mdi-menu-down</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <div v-if="getProfile.role == 0">
                    <SuperAdmin></SuperAdmin>
                </div>
                <div v-if="getProfile.role == 1">
                    <Admin></Admin>
                </div>
                <div v-if="getProfile.role == 2">
                    <MainResident></MainResident>
                </div>
                <div v-if="getProfile.role == 3 || getProfile.role === 5">
                    <Resident></Resident>
                </div>
                <div v-if="getProfile.role == 4">
                    <Guard></Guard>
                </div>
            </v-list>
        </v-navigation-drawer>
        <v-navigation-drawer
            v-model="drawer"
            v-if="getProfile.role === 4 && isAuthenticated && getProfile.enable_parcel"
            :clipped="$vuetify.breakpoint.lgAndUp"
            app
            permanent
            right
            color="gray"
            expand-on-hover
            width="120px"
            mini-variant-width="100px"
        >
          <v-list rounded v-if="packages.length > 0">
              <v-list-item
                  color="grey-lighten-4"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-badge overlap color="green">
                      <template v-slot:badge>
                        <span>{{packages[0].total}}</span>
                      </template>
                      <v-icon
                          color="black"
                          large
                          v-bind="attrs"
                          v-on="on"
                          @click="getPackages()"
                      >
                        mdi-truck-delivery
                      </v-icon>
                    </v-badge>
                  </template>
                  <span>Actualizar</span>
                </v-tooltip>
              </v-list-item>
              <v-divider class="my-2"></v-divider>
              <v-list-item
                  color="grey-lighten-4"
                  link
                  @click="errores = [], cleanFields(), getParcelCompany(), getHouses(), dialogAddParcel = true"
              ><v-icon color="blue" large>mdi-package-variant-closed-plus</v-icon></v-list-item>
              <v-divider class="my-2"></v-divider>
              <v-list-item
                  v-for="(item, i) in packages[0].packages" v-bind:key="i"
                  link
              >
                <v-list-item-content>
                  <v-list-item-title @click="getVigilants(), getResidents(item.idHouse), getParcelByHouse(item.idHouse)">{{ item.shortcut }} ({{ item.count }})</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
          </v-list>
          <v-list rounded v-else>
              <v-list-item
                  color="grey-lighten-4"
              >
                <v-icon color="black" large @click="getPackages()">mdi-truck-delivery</v-icon>
              </v-list-item>
              <v-divider class="my-2"></v-divider>
              <v-list-item
                  color="grey-lighten-4"
                  link
                  @click="errores = [], cleanFields(), getParcelCompany(), getHouses(), dialogAddParcel = true"
              ><v-icon color="blue" large>mdi-package-variant-closed-plus</v-icon></v-list-item>
              <v-divider class="my-2"></v-divider>
          </v-list>
        </v-navigation-drawer>
        <v-app-bar
                :clipped-left="$vuetify.breakpoint.lgAndUp"
                :clipped-right="$vuetify.breakpoint.lgAndUp"
                app
                dark
                color="primary"
                :src="getProfile.wallpaper"
        >
            <template v-slot:img="{ props }">
                <v-img
                        v-bind="props"
                        gradient="to bottom left, rgba(19,84,122,.5), rgba(128,208,199,.8)"
                ></v-img>
            </template>
            <v-app-bar-nav-icon v-if="isAuthenticated" @click.stop="drawer = !drawer" />
            <v-toolbar-title
                    style="width: 300px"
                    class="ml-0 pl-4"
            >
                <span>
                    <strong>
                        <router-link :to="{ name: 'home'}" class="text">
                            {{$t('intrare_residencial')}}
                        </router-link>
                    </strong>
                </span>
            </v-toolbar-title>
            <v-spacer />
            <v-menu
                    v-if="isAuthenticated && getProfile.role == 1 && hasPendingDocuments"
                    v-model="notificationMenu"
                    offset-y
                    left
                    :close-on-content-click="false"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-badge
                            :value="pendingCount > 0"
                            color="error"
                            overlap
                            bordered
                    >
                        <template v-slot:badge>
                            <span>{{ pendingCount }}</span>
                        </template>
                        <v-btn
                                icon
                                large
                                v-bind="attrs"
                                v-on="on"
                        >
                            <v-icon>mdi-bell</v-icon>
                        </v-btn>
                    </v-badge>
                </template>
                <v-card min-width="320">
                    <v-list>
                        <v-subheader>Notificaciones</v-subheader>
                        <v-list-item
                                v-if="!getProfile.rulebook_url"
                                link
                                router
                                to="/settings"
                        >
                            <v-list-item-icon>
                                <v-icon color="warning">mdi-file-document-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-subtitle class="text-wrap">
                                    Te recordamos que ya puedes subir el Reglamento interno del Fraccionamiento
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item
                                v-if="!getProfile.privacy_notice_url"
                                link
                                router
                                to="/settings"
                        >
                            <v-list-item-icon>
                                <v-icon color="warning">mdi-shield-account-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-subtitle class="text-wrap">
                                    Te recordamos que ya puedes subir el Aviso de Privacidad del Fraccionamiento
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-menu>
            <v-btn
                v-if="getProfile.role === 4 && isAuthenticated && getProfile.water_service_enabled"
                icon
                large
                @click="getVigilants(), getWaterServices() ,dialogUpdateWaterService = true"
            >
              <v-icon>mdi-tanker-truck</v-icon>
            </v-btn>
            <v-btn
                    icon
                    large
                    @click="setLocale('es')"
            >
                <v-avatar
                        size="32px"
                        item
                >
                    <div style="font-size:25px">
                        <flag iso="mx">
                        </flag>
                    </div>
                </v-avatar>
            </v-btn>
            <v-btn
                    icon
                    large
                    @click="setLocale('en')"
            >
                <v-avatar
                        size="32px"
                        item
                >
                    <div style="font-size:25px">
                        <flag iso="us">
                        </flag>
                    </div>
                </v-avatar>
            </v-btn>
            <v-btn icon v-if="isAuthenticated" @click="logout()">
                <v-icon>mdi-account-arrow-right</v-icon>
            </v-btn>
        </v-app-bar>
        <v-content>
            <offline @detected-condition="handleConnectivityChange">
            </offline>
            <v-container
                    v-if="bandOnline === true"
                    class="fill-height"
                    fluid
            >
                <router-view></router-view>
            </v-container>
            <v-container
                    v-else
                    class="fill-height"
                    fluid
            >
                <MsgOffline></MsgOffline>
            </v-container>
        </v-content>
        <v-footer>
            <Foot/>
        </v-footer>
    </v-app>
</template>

<script>
import offline from 'v-offline'
import Foot from './components/Foot'
import { USER_REQUEST } from '@/store/actions/user'
import { mapGetters, mapState } from 'vuex'
import { AUTH_LOGOUT } from './store/actions/auth'
import SuperAdmin from '@/components/Menu/super_admin.vue'
import Admin from '@/components/Menu/admin.vue'
import MainResident from '@/components/Menu/main_resident.vue'
import Resident from '@/components/Menu/resident.vue'
import Guard from '@/components/Menu/guard.vue'
import Snackbar from '@/components/snackbar.vue'
import MsgOffline from '@/views/common/offline'
import { extend, localize } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'
import store from '@/store'
import axios from 'axios'
import DialogShow from './components/dialogShow.vue'

let nextId = 1

// import es from 'vee-validate/dist/locale/es.json'
// import en from 'vee-validate/dist/locale/en.json'

extend('required', required)

// Install English and Spanish localizations.
localize({
  es: {
    messages: {
      required: 'Este campo es Obligatorio'
    }
  },
  en: {
    messages: {
      required: 'This field is required'
    }
  }
})

export default {
  name: 'App',
  components: {
    Foot,
    SuperAdmin,
    Admin,
    MainResident,
    Resident,
    Guard,
    Snackbar,
    DialogShow,
    offline,
    MsgOffline
  },
  data: () => ({
    drawer: null,
    notificationMenu: false,
    bandOnline: true,
    items: [
      { title: 'A23' },
      { title: 'P207' },
      { title: 'R22' },
      { title: 'R56' }
    ],
    dialogAddParcel: false,
    dialogUpdateParcel: false,
    dialogUpdateWaterService: false,
    loading: false,
    address: '',
    guide_number: '',
    vigilant_name: '',
    vigilant_name_water_service: '',
    resident_name: '',
    errores: [],
    idParcelCompany: '',
    parcel_companies: [],
    idHouse: null,
    houses: [],
    residents: [],
    vigilants: [],
    packages: [],
    headersPackage: [],
    headersWaterService: [],
    packagesByHouse: [],
    waterServices: [],
    selected: [],
    selectedWaterServices: [],
    comboboxAux: null,
    addressee: null
  }),
  created () {
    if (this.$store.getters.isAuthenticated) {
      this.getPackages()
      this.$store.dispatch(USER_REQUEST)
      this.connectToWebSocket()
      if (localStorage.getItem('banderaQR') !== null) {
        if (localStorage.getItem('banderaQR') === 'true') {
          console.log('Band QR', localStorage.getItem('banderaQR'))
          this.$store.commit('enableBandQr', true)
        } else {
          this.$store.commit('enableBandQr', false)
        }
      }
      if (localStorage.getItem('banderaCam') !== null) {
        if (localStorage.getItem('banderaCam') === 'true') {
          console.log('banderaCam', localStorage.getItem('banderaCam'))
          this.$store.commit('enableBandCam', true)
        } else {
          this.$store.commit('enableBandCam', false)
        }
      }
    }
  },
  beforeUpdate () {
    this.headersPackage = [
      {
        text: this.$t('company'),
        align: 'left',
        sortable: true,
        value: 'idParcelCompany'
      },
      {
        text: this.$t('guide_number'),
        align: 'left',
        sortable: true,
        value: 'tracking_number'
      }
    ]
    this.headersWaterService = [
      {
        text: this.$t('direccion'),
        align: 'left',
        sortable: true,
        value: 'house_address'
      },
      {
        text: this.$t('date_time_request'),
        align: 'left',
        sortable: true,
        value: 'date_time_receipt'
      }
    ]
  },
  methods: {
    getResidents (idHouse) {
      // this.loadingHouses = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/residents_fullname/all/' + idHouse,
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          console.log(response.status)
          // this.loadingHouses = false
          this.residents = response.data
        })
        .catch(error => {
          // this.loadingHouses = false
          console.log(error)
        })
    },
    fillResidents () {
      console.log('Fill Residents')
      console.log(this.idHouse)
      if (this.idHouse === undefined) {
        this.residents = []
        this.addressee = null
      } else {
        this.getResidents(this.idHouse)
      }
    },
    addItem (name) {
      const newItem = {
        id: nextId++,
        fullname: name
      }
      this.residents.push(newItem)
      return newItem
    },
    onChangeComboBoxResidents (entry) {
      if (typeof entry === 'string' && entry.trim()) {
        const item = this.residents.find(item => item.fullname === entry)
        if (item) {
          this.addressee = item
          this.resident_name = item
        } else {
          this.addressee = this.addItem(entry)
          this.resident_name = this.addItem(entry)
        }
      }
    },
    addItemVigilant (name) {
      const newItem = {
        id: nextId++,
        fullname: name
      }
      this.vigilants.push(newItem)
      return newItem
    },
    onChangeComboBoxVigilants (entry) {
      if (typeof entry === 'string' && entry.trim()) {
        const item = this.vigilants.find(item => item.fullname === entry)
        if (item) {
          this.vigilant_name = item
        } else {
          this.vigilant_name = this.addItemVigilant(entry)
        }
      }
    },
    onChangeComboBoxVigilantsWaterService (entry) {
      if (typeof entry === 'string' && entry.trim()) {
        const item = this.vigilants.find(item => item.fullname === entry)
        if (item) {
          this.vigilant_name_water_service = item
        } else {
          this.vigilant_name_water_service = this.addItemVigilant(entry)
        }
      }
    },
    packageDelivery () {
      this.loading = true
      console.log(this.selected)
      let ids = []
      for (let i = 0; i < this.selected.length; i++) {
        ids.push(this.selected[i].id)
      }
      console.log(ids)
      const config = {
        method: 'put',
        url: 'https://residencial-services.intrare.app/parcel_many_update/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          ids: ids,
          resident_name: (this.resident_name === null || this.resident_name === undefined) ? null : this.resident_name.fullname,
          vigilant_name: (this.vigilant_name === null || this.vigilant_name === undefined) ? null : this.vigilant_name.fullname
        }
      }
      axios(config)
        .then(ok => {
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('mensaje_paqueteria_entregado'))
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
            }
          }
        })
    },
    waterServiceDelivery () {
      this.loading = true
      console.log(this.selectedWaterServices)
      let ids = []
      for (let i = 0; i < this.selectedWaterServices.length; i++) {
        ids.push(this.selectedWaterServices[i].id)
      }
      console.log(ids)
      const config = {
        method: 'put',
        url: 'https://residencial-services.intrare.app/water_service_many_update/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          ids: ids,
          vigilant_name: (this.vigilant_name_water_service === null || this.vigilant_name_water_service === undefined) ? null : this.vigilant_name_water_service.fullname
        }
      }
      axios(config)
        .then(ok => {
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_water_service_delivered'))
          setTimeout(this.clearWaterService, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
            }
          }
        })
    },
    example: item => (item.street === null ? 'n/a' : item.street) + ' ' + (item.number === null ? 'n/a' : item.number),
    customFilterHouse (item, queryText) {
      var text = ''
      if (item.number === null || item.number === '') {
        text = 'n/a'
      } else {
        text = item.number.toLowerCase()
      }
      const searchText = queryText.toLowerCase()
      return text.indexOf(searchText) > -1
    },
    addParcel () {
      this.loading = true
      console.log('Dato Destinatario = ', this.addressee)
      this.errores = []
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/parcel_create_get/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          tracking_number: this.guide_number,
          idParcelCompany: this.idParcelCompany,
          idHouse: this.idHouse,
          addressee: (this.addressee === null || this.addressee === undefined) ? null : this.addressee.fullname
        }
      }
      axios(config)
        .then(ok => {
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('mensaje_paqueteria_alta'))
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
            }
          }
        })
    },
    clear: function () {
      this.cleanFields()
      this.getPackages()
      this.errores = []
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
      this.dialogUpdateParcel = false
      this.loading = false
    },
    clearWaterService: function () {
      this.cleanFields()
      this.errores = []
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
      this.dialogUpdateWaterService = false
      this.loading = false
    },
    getHouses: function () {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/house/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.houses = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getPackages () {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/parcel_special_vigilant_get/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          if (response.status === 204) {
            this.packages = []
          } else {
            this.packages = response.data
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getParcelCompany: function () {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/parcel_company_create_get/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.parcel_companies = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    textParcelCompany: item => (item.name === null ? 'n/a' : item.name),
    customFilterParcelCompany (item, queryText) {
      var text = ''
      if (item.name === null) {
        text = 'n/a'
      } else {
        text = item.name.toLowerCase()
      }
      const searchText = queryText.toLowerCase()
      return text.indexOf(searchText) > -1
    },
    getParcelByHouse (idHouse) {
      this.selected = []
      this.resident_name = ''
      this.vigilant_name = ''
      this.loading = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/parcel_by_house_get/' + idHouse,
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.loading = false
          this.packagesByHouse = response.data
          this.dialogUpdateParcel = true
        })
        .catch(error => {
          this.loading = false
          console.log(error)
        })
    },
    getWaterServices () {
      this.selectedWaterServices = []
      this.vigilant_name_water_service = ''
      this.loading = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/water_service_vigilant_get/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.loading = false
          this.waterServices = response.data
          this.dialogUpdateWaterService = true
        })
        .catch(error => {
          this.loading = false
          console.log(error)
        })
    },
    getVigilants () {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/vigilant_only_fullname/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.vigilants = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    cleanFields () {
      this.address = ''
      this.addressee = null
      this.residents = []
      this.guide_number = ''
      this.idParcelCompany = ''
      this.idHouse = null
      this.resident_name = ''
      this.vigilant_name = ''
    },
    connectToWebSocket () {
      const websocket = new WebSocket('wss://residencial-services.intrare.app/ws/socket/devices/' + localStorage.getItem('idGuardHouse') + '/?token=' + store.getters.getToken)
      websocket.onopen = this.onOpen
      websocket.onclose = this.onClose
      websocket.onmessage = this.onMessage
      websocket.onerror = this.onError
    },
    onOpen (event) {
      console.log('Connection opened.', event.data)
    },
    onClose (event) {
      console.log('Connection closed.', event.data)
      // Try and Reconnect after five seconds
      if (this.$store.getters.isAuthenticated && this.getProfile.role === 4) {
        setTimeout(this.connectToWebSocket, 5000)
      }
    },
    onMessage (event) {
      const message = JSON.parse(event.data)
      switch (message.classification) {
        case 'qr':
          if (message.data.length === 20) {
            const config3 = {
              method: 'get',
              url: 'https://residencial-services.intrare.app/event/qr/' + message.data,
              headers: {
                'Content-Type': 'application/json',
                'authorization': 'Token ' + store.getters.getToken
              }
            }
            axios(config3)
              .then(response => {
                var aux = localStorage.getItem('listStoreQrCodes') === null ? [] : JSON.parse(localStorage.getItem('listStoreQrCodes'))
                var item = message
                console.log('Datos del Evento')
                console.log(response.data)
                var fullItem40 = Object.assign(item, { 'status': 20 })
                var fullItem50 = Object.assign(fullItem40, { 'info': response.data })
                console.log(fullItem50)
                aux.push(fullItem50)
                localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
              })
              .catch(error => {
                console.log(error)
                if (error.request.status === 400) {
                  console.log('Evento cancelado')
                  var aux60 = localStorage.getItem('listStoreQrCodes') === null ? [] : JSON.parse(localStorage.getItem('listStoreQrCodes'))
                  var item60 = message
                  var fullItem60 = Object.assign(item60, { 'status': 21 })
                  console.log(fullItem60)
                  aux60.push(fullItem60)
                  localStorage.setItem('listStoreQrCodes', JSON.stringify(aux60))
                  this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                }
                if (error.request.status === 404) {
                  console.log('NO Valido')
                  var aux = localStorage.getItem('listStoreQrCodes') === null ? [] : JSON.parse(localStorage.getItem('listStoreQrCodes'))
                  var item = message
                  var fullItem12 = Object.assign(item, { 'status': 0 })
                  console.log(fullItem12)
                  aux.push(fullItem12)
                  localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                  this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                }
              })
          } else {
            const config = {
              method: 'get',
              url: 'https://residencial-services.intrare.app/vigilant/qr/' + message.data,
              headers: {
                'Content-Type': 'application/json',
                'authorization': 'Token ' + store.getters.getToken
              }
            }
            axios(config).then(response => {
              switch (response.data.type_code) {
                case 0: // Invitation
                  const config2 = {
                    method: 'get',
                    url: 'https://residencial-services.intrare.app/Access/Get/ByCode/' + message.data + '/',
                    headers: {
                      'Content-Type': 'application/json',
                      'authorization': 'Token ' + store.getters.getToken
                    }
                  }
                  axios(config2).then(response2 => {
                    var aux = localStorage.getItem('listStoreQrCodes') === null ? [] : JSON.parse(localStorage.getItem('listStoreQrCodes'))
                    var item = message
                    console.log(response2.data)
                    if (response.data.invitation.typeInv === 0) { // Tipo de Invitación Normal
                      if (response2.data.length > 0 && response2.data[0].dateTime_EntranceAccess != null && response2.data[0].dateTime_ExitAccess != null) {
                        // alert('Ya se completó el acceso con la invitación Correspondiente.')
                        // this.head_color = 'orange display-1 text--primary'
                        // this.errores_guard = this.$t('mensaje_acceso_completo')
                        // this.dialog_errores = true
                        console.log('COMPLETO')
                        var fullItem = Object.assign(item, { 'status': 1 })
                        console.log(fullItem)
                        aux.push(fullItem)
                        localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                        this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                      } else {
                        if (response2.data.length > 0) {
                          // this.entrada = false
                          // this.salida = true
                          // this.dialog = true
                          // this.activar_camara = false
                          console.log('SALIDA')
                          var fullItem2 = Object.assign(item, { 'status': 3 })
                          var fullItem3 = Object.assign(fullItem2, { 'info': response.data })
                          var fullItemAccess = Object.assign(fullItem3, { 'access': response2.data[0].id })
                          console.log(fullItemAccess)
                          aux.push(fullItemAccess)
                          localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                          this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                        } else {
                          var fechaLocal1 = new Date(this.get_current_date())
                          const readableDate = response.data.invitation.dateInv.substring(3, 6) + response.data.invitation.dateInv.substring(0, 2) + response.data.invitation.dateInv.substring(5, 10)
                          var fechaAccesoEntrada1 = new Date(readableDate)
                          if (fechaAccesoEntrada1.getTime() !== fechaLocal1.getTime()) {
                            console.log('Fuera de FECHA')
                            var fullItem17 = Object.assign(item, { 'status': 4 })
                            console.log(fullItem17)
                            aux.push(fullItem17)
                            localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                            this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                          } else {
                            console.log('ENTRADA')
                            if (response.data.invitation.temporalToken === '') {
                              var fullItem4 = Object.assign(item, { 'status': 2 })
                              var fullItem5 = Object.assign(fullItem4, { 'info': response.data })
                              console.log(fullItem5)
                              aux.push(fullItem5)
                              localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                              this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                            } else {
                              localStorage.setItem('qr_code_temporal', message.data)
                              localStorage.setItem('host_IdFront', response.data.invitation.hostIdFront)
                              localStorage.setItem('host_avatar', response.data.invitation.avatarHost)
                              localStorage.setItem('host_first_name', response.data.invitation.hostFirstName)
                              localStorage.setItem('host_last_name', response.data.invitation.hostLastName)
                              localStorage.setItem('host_cellphone', response.data.invitation.hostCellphone)
                              localStorage.setItem('host_street', response.data.invitation.street)
                              localStorage.setItem('host_number_house', response.data.invitation.numberHouse)
                              localStorage.setItem('host_supplier', response.data.invitation.supplier)
                              localStorage.setItem('vacation_mode', response.data.invitation.vacation_mode)
                              localStorage.setItem('allow_access_visitors', response.data.invitation.allow_access_visitors)
                              this.$router.push('/booth_registration/' + response.data.invitation.temporalToken)
                            }
                          }
                        }
                      }
                    }
                    if (response.data.invitation.typeInv === 1) { // Tipo de Invitación Pre registro en Caseta
                      if (response2.data.length > 0 && response2.data[0].dateTime_EntranceAccess != null && response2.data[0].dateTime_ExitAccess != null) {
                        // alert('Ya se completó el acceso con la invitación Correspondiente.')
                        // this.head_color = 'orange display-1 text--primary'
                        // this.errores_guard = this.$t('mensaje_acceso_completo')
                        // this.dialog_errores = true
                        console.log('COMPLETO')
                        var fullItem44 = Object.assign(item, { 'status': 1 })
                        console.log(fullItem44)
                        aux.push(fullItem44)
                        localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                        this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                      } else {
                        if (response2.data.length > 0) {
                          // this.entrada = false
                          // this.salida = true
                          // this.dialog = true
                          // this.activar_camara = false
                          console.log('SALIDA')
                          var fullItem222 = Object.assign(item, { 'status': 3 })
                          var fullItem333 = Object.assign(fullItem222, { 'info': response.data })
                          var fullItemAccess0 = Object.assign(fullItem333, { 'access': response2.data[0].id })
                          console.log(fullItemAccess0)
                          aux.push(fullItemAccess0)
                          localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                          this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                        } else {
                          var fechaLocal111 = new Date(this.get_current_date())
                          const readableDate = response.data.invitation.dateInv.substring(3, 6) + response.data.invitation.dateInv.substring(0, 2) + response.data.invitation.dateInv.substring(5, 10)
                          var fechaAccesoEntrada111 = new Date(readableDate)
                          if (fechaAccesoEntrada111.getTime() !== fechaLocal111.getTime()) {
                            console.log('Fuera de FECHA')
                            var fullItem177 = Object.assign(item, { 'status': 4 })
                            console.log(fullItem177)
                            aux.push(fullItem177)
                            localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                            this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                          } else {
                            console.log('ENTRADA')
                            if (response.data.invitation.temporalToken === '') {
                              var fullItem41 = Object.assign(item, { 'status': 2 })
                              var fullItem51 = Object.assign(fullItem41, { 'info': response.data })
                              console.log(fullItem51)
                              aux.push(fullItem51)
                              localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                              this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                            } else {
                              localStorage.setItem('qr_code_temporal', message.data)
                              localStorage.setItem('host_IdFront', response.data.invitation.hostIdFront)
                              localStorage.setItem('host_avatar', response.data.invitation.avatarHost)
                              localStorage.setItem('host_first_name', response.data.invitation.hostFirstName)
                              localStorage.setItem('host_last_name', response.data.invitation.hostLastName)
                              localStorage.setItem('host_cellphone', response.data.invitation.hostCellphone)
                              localStorage.setItem('host_street', response.data.invitation.street)
                              localStorage.setItem('host_number_house', response.data.invitation.numberHouse)
                              localStorage.setItem('host_supplier', response.data.invitation.supplier)
                              localStorage.setItem('vacation_mode', response.data.invitation.vacation_mode)
                              localStorage.setItem('allow_access_visitors', response.data.invitation.allow_access_visitors)
                              this.$router.push('/booth_registration/' + response.data.invitation.temporalToken)
                            }
                          }
                        }
                      }
                    }
                    if (response.data.invitation.typeInv === 2) { // Tipo de invitacion recurrente
                      if (response2.data.length === 0) {
                        var fechaLocal2 = new Date(this.get_current_date())
                        const readableDate = response.data.invitation.expiration.substring(3, 6) + response.data.invitation.expiration.substring(0, 2) + response.data.invitation.expiration.substring(5, 10)
                        var fechaExpiracion = new Date(readableDate)
                        console.log('FECHA DE EXPIRACION = ', fechaExpiracion.getTime())
                        console.log('FECHA ACTUAL = ', fechaLocal2)
                        console.log('FECHA DE EXPIRACION = ', response.data.invitation.expiration)
                        console.log('FECHA ACTUAL = ', fechaLocal2.getTime())
                        console.log('Día Actual = ', fechaLocal2.getDay())
                        console.log('Día Expiración = ', fechaExpiracion.getDay())
                        if (fechaLocal2.getDay() !== fechaExpiracion.getDay()) {
                          console.log('Día Diferente a la invitación recurrente.')
                        }
                        // if (fechaAccesoEntrada2.getTime() > fechaLocal2.getTime()) {
                        //   console.log('FECHA DE EXPIRACION > ACTUAL')
                        // }
                        // if (fechaAccesoEntrada2.getTime() < fechaLocal2.getTime()) {
                        //   console.log('FECHA DE EXPIRACION < ACTUAL')
                        // }
                        // if (fechaAccesoEntrada2.getTime() === fechaLocal2.getTime()) {
                        //   console.log('FECHA DE EXPIRACION = ACTUAL')
                        // }
                        if (fechaLocal2.getTime() > fechaExpiracion.getTime()) {
                          console.log('Expirada')
                          var fullItem18 = Object.assign(item, { 'status': 5 })
                          console.log(fullItem18)
                          aux.push(fullItem18)
                          localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                          this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                        } else {
                          var dias = response.data.invitation.diary
                          var diasJS = ['6', '0', '1', '2', '3', '4', '5']
                          console.log(dias)
                          console.log('Dia = ', diasJS[fechaLocal2.getDay()])
                          if (dias.includes(diasJS[fechaLocal2.getDay()]) === false) {
                            console.log('Día inválido')
                            var fullItem19 = Object.assign(item, { 'status': 6 })
                            console.log(fullItem19)
                            aux.push(fullItem19)
                            localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                            this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                          } else {
                            console.log('ENTRADA RECURRENTE')
                            if (response.data.invitation.temporalToken === '') {
                              var fullItem6 = Object.assign(item, { 'status': 2 })
                              var fullItem7 = Object.assign(fullItem6, { 'info': response.data })
                              console.log(fullItem7)
                              aux.push(fullItem7)
                              localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                              this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                            } else {
                              localStorage.setItem('qr_code_temporal', message.data)
                              localStorage.setItem('host_IdFront', response.data.invitation.hostIdFront)
                              localStorage.setItem('host_avatar', response.data.invitation.avatarHost)
                              localStorage.setItem('host_first_name', response.data.invitation.hostFirstName)
                              localStorage.setItem('host_last_name', response.data.invitation.hostLastName)
                              localStorage.setItem('host_cellphone', response.data.invitation.hostCellphone)
                              localStorage.setItem('host_street', response.data.invitation.street)
                              localStorage.setItem('host_number_house', response.data.invitation.numberHouse)
                              localStorage.setItem('host_supplier', response.data.invitation.supplier)
                              localStorage.setItem('vacation_mode', response.data.invitation.vacation_mode)
                              localStorage.setItem('allow_access_visitors', response.data.invitation.allow_access_visitors)
                              this.$router.push('/booth_registration/' + response.data.invitation.temporalToken)
                            }
                          }
                        }
                      } else {
                        if (response2.data[0].status === 1) {
                          // this.entrada = false
                          // this.salida = true
                          // this.dialog = true
                          // this.activar_camara = false
                          console.log('SALIDA RECURRENTE', response2.data[0])
                          var fullItem8 = Object.assign(item, { 'status': 3 })
                          var fullItem9 = Object.assign(fullItem8, { 'info': response.data })
                          var fullItemAccess2 = Object.assign(fullItem9, { 'access': response2.data[0].id })
                          console.log(fullItemAccess2)
                          aux.push(fullItemAccess2)
                          localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                          this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                        } else {
                          var fechaLocal = new Date(this.get_current_date())
                          const readableDate = response2.data[0].dateTime_EntranceAccess.substring(3, 6) + response2.data[0].dateTime_EntranceAccess.substring(0, 2) + response2.data[0].dateTime_EntranceAccess.substring(5, 10)
                          const expirationDate = response.data.invitation.expiration.substring(3, 6) + response.data.invitation.expiration.substring(0, 2) + response.data.invitation.expiration.substring(5, 10)
                          var fechaAccesoEntrada = new Date(readableDate)
                          var expirationDate2 = new Date(expirationDate)
                          console.log('FECHA DE EXPIRACION = ', expirationDate2.getTime())
                          console.log('FECHA ACTUAL = ', fechaLocal)
                          console.log('FECHA DE EXPIRACION = ', response.data.invitation.expiration)
                          console.log('FECHA ACTUAL = ', fechaLocal.getTime())
                          console.log('Día Actual = ', fechaLocal.getDay())
                          console.log('Día Expiración = ', expirationDate2.getDay())
                          if (fechaLocal.getDay() !== expirationDate2.getDay()) {
                            console.log('Día Diferente a la invitación recurrente.')
                          }
                          if (fechaAccesoEntrada.getTime() !== fechaLocal.getTime()) {
                            if (fechaLocal.getTime() > expirationDate2.getTime()) {
                              console.log('Expirada')
                              var fullItem20 = Object.assign(item, { 'status': 5 })
                              console.log(fullItem20)
                              aux.push(fullItem20)
                              localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                              this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                            } else {
                              dias = response.data.invitation.diary
                              diasJS = ['6', '0', '1', '2', '3', '4', '5']
                              console.log(dias)
                              console.log('Dia = ', diasJS[fechaLocal.getDay()])
                              if (dias.includes(diasJS[fechaLocal.getDay()]) === false) {
                                console.log('Día inválido')
                                var fullItem21 = Object.assign(item, { 'status': 6 })
                                console.log(fullItem21)
                                aux.push(fullItem21)
                                localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                                this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                              } else {
                                console.log('ENTRADA RECURRENTE')
                                var fullItem22 = Object.assign(item, { 'status': 2 })
                                var fullItem23 = Object.assign(fullItem22, { 'info': response.data })
                                console.log(fullItem23)
                                aux.push(fullItem23)
                                localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                                this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                              }
                            }
                          } else {
                            // this.clear_without_activate_camera()
                            // this.head_color = 'orange display-1 text--primary'
                            // this.errores_guard = this.$t('mensaje_acceso_completo')
                            // this.dialog_errores = true
                            console.log('COMPLETO RECURRENTE')
                            var fullItem10 = Object.assign(item, { 'status': 1 })
                            var fullItem11 = Object.assign(fullItem10, { 'info': response.data })
                            console.log(fullItem11)
                            aux.push(fullItem11)
                            localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                            this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                          }
                        }
                      }
                    }
                  }).catch(error => {
                    console.log(error)
                  })
                  break
                case 1: // Residente
                  console.log('Residente')
                  var aux = localStorage.getItem('listStoreQrCodes') === null ? [] : JSON.parse(localStorage.getItem('listStoreQrCodes'))
                  var item = message
                  var fullItem13 = Object.assign(item, { 'info': response.data })
                  var fullItem14 = Object.assign(fullItem13, { 'status': -1 })
                  console.log(fullItem14)
                  aux.push(fullItem14)
                  localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                  this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                  break
                case 2: // Worker
                  const config3 = {
                    method: 'post',
                    url: 'https://residencial-services.intrare.app/WorkerAccess/Status/',
                    headers: {
                      'Content-Type': 'application/json',
                      'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                      'qr_code': message.data
                    }
                  }
                  axios(config3)
                    .then(response3 => {
                      console.log(response3.data.status)
                      var aux = localStorage.getItem('listStoreQrCodes') === null ? [] : JSON.parse(localStorage.getItem('listStoreQrCodes'))
                      var item = message
                      switch (response3.data.status) {
                        case 10:
                          var fullItem15 = Object.assign(item, { 'info': response.data })
                          var fullItem16 = Object.assign(fullItem15, { 'status': 10 })
                          console.log(fullItem16)
                          aux.push(fullItem16)
                          localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                          this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                          break
                        case 11:
                          var fullItem17 = Object.assign(item, { 'info': response.data })
                          var fullItem18 = Object.assign(fullItem17, { 'status': 11 })
                          console.log(fullItem18)
                          aux.push(fullItem18)
                          localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                          this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                          break
                        case 12:
                          var fullItem19 = Object.assign(item, { 'status': 12 })
                          console.log(fullItem19)
                          aux.push(fullItem19)
                          localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                          this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                          break
                        case 13:
                          var fullItem20 = Object.assign(item, { 'status': 13 })
                          console.log(fullItem20)
                          aux.push(fullItem20)
                          localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                          this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
                          break
                      }
                    })
                    .catch(error => {
                      console.log(error)
                    })
                  break
              }
            }).catch(error => {
              console.log(error)
              if (error.request.status === 404) {
                console.log('NO Valido')
                var aux = localStorage.getItem('listStoreQrCodes') === null ? [] : JSON.parse(localStorage.getItem('listStoreQrCodes'))
                var item = message
                var fullItem12 = Object.assign(item, { 'status': 0 })
                console.log(fullItem12)
                aux.push(fullItem12)
                localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
                this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
              }
              if (error.request.status === 401) {
                console.log('Invitacion Expirada')
                var listQrCodesAux = localStorage.getItem('listStoreQrCodes') === null ? [] : JSON.parse(localStorage.getItem('listStoreQrCodes'))
                var itemAux = message
                var fullItemAux = Object.assign(itemAux, { 'status': 5 })
                console.log(fullItemAux)
                listQrCodesAux.push(fullItemAux)
                localStorage.setItem('listStoreQrCodes', JSON.stringify(listQrCodesAux))
                this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
              }
              if (error.request.status === 403) {
                console.log('Invitacion Cancelada')
                var listQrCodesAux2 = localStorage.getItem('listStoreQrCodes') === null ? [] : JSON.parse(localStorage.getItem('listStoreQrCodes'))
                var itemAux2 = message
                var fullItemAux2 = Object.assign(itemAux2, { 'status': -3 })
                console.log(fullItemAux2)
                listQrCodesAux2.push(fullItemAux2)
                localStorage.setItem('listStoreQrCodes', JSON.stringify(listQrCodesAux2))
                this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
              }
              if (error.request.status === 423) {
                console.log('Invitacion Cancelada')
                var listQrCodesAux3 = localStorage.getItem('listStoreQrCodes') === null ? [] : JSON.parse(localStorage.getItem('listStoreQrCodes'))
                var itemAux3 = message
                var fullItemAux3 = Object.assign(itemAux3, { 'status': -5 })
                console.log(fullItemAux3)
                listQrCodesAux3.push(fullItemAux3)
                localStorage.setItem('listStoreQrCodes', JSON.stringify(listQrCodesAux3))
                this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
              }
            })
          }
          if (localStorage.getItem('qr_devices') !== null) {
            console.log('Dato recivido de QR')
            let band = false
            let devicesAux = JSON.parse(localStorage.getItem('qr_devices'))
            console.log('Auxiluar = ', devicesAux)
            for (let i = 0; !band && i < devicesAux.length; i++) {
              if (devicesAux[i].label === message.label) {
                console.log(devicesAux[i].label, '===', message.label)
                devicesAux[i] = Object.assign(devicesAux[i], { 'data': message.data })
                localStorage.setItem('qr_devices', JSON.stringify(devicesAux))
                this.$store.commit('setQRDevices', JSON.parse(localStorage.getItem('qr_devices')))
                band = true
              }
            }
            console.log(JSON.parse(localStorage.getItem('qr_devices')))
          }
          break
        case 'cam':
          if (localStorage.getItem('banderaAdditionalPerson') !== null || localStorage.getItem('banderaINEBack') !== null) {
            console.log('banderaAdditionalPerson', localStorage.getItem('banderaAdditionalPerson'))
            console.log('banderaINEBack', localStorage.getItem('banderaINEBack'))
            if (localStorage.getItem('banderaAdditionalPerson') === 'true') {
              console.log('Foto Additional Person')
              var auxAdditional = localStorage.getItem('listStorePhotosCameraAdditionalPerson') === null ? [] : JSON.parse(localStorage.getItem('listStorePhotosCameraAdditionalPerson'))
              while (auxAdditional.length > 0) {
                auxAdditional.pop()
              }
              auxAdditional.push(message)
              localStorage.setItem('listStorePhotosCameraAdditionalPerson', JSON.stringify(auxAdditional))
              this.$store.commit('setPhotosAdditionalPerson', JSON.parse(localStorage.getItem('listStorePhotosCameraAdditionalPerson')))
              if (localStorage.getItem('cam_devices') !== null) {
                console.log('Dato recivido de CAM')
                let band = false
                let devicesAux = JSON.parse(localStorage.getItem('cam_devices'))
                console.log('Auxiluar = ', devicesAux)
                for (let i = 0; !band && i < devicesAux.length; i++) {
                  if (devicesAux[i].label === message.label) {
                    console.log(devicesAux[i].label, '===', message.label)
                    devicesAux[i] = Object.assign(devicesAux[i], { 'data': message.data })
                    localStorage.setItem('cam_devices', JSON.stringify(devicesAux))
                    this.$store.commit('setCamDevices', JSON.parse(localStorage.getItem('cam_devices')))
                    band = true
                  }
                }
                console.log(JSON.parse(localStorage.getItem('cam_devices')))
              }
            } else {
              if (localStorage.getItem('banderaINEBack') === 'true') {
                console.log('Foto INE Back')
                var auxAdditional2 = localStorage.getItem('listStorePhotosCameraINEBack') === null ? [] : JSON.parse(localStorage.getItem('listStorePhotosCameraINEBack'))
                while (auxAdditional2.length > 0) {
                  auxAdditional2.pop()
                }
                auxAdditional2.push(message)
                localStorage.setItem('listStorePhotosCameraINEBack', JSON.stringify(auxAdditional2))
                this.$store.commit('setPhotosINEBack', JSON.parse(localStorage.getItem('listStorePhotosCameraINEBack')))
                if (localStorage.getItem('cam_devices') !== null) {
                  console.log('Dato recivido de CAM')
                  let band = false
                  let devicesAux = JSON.parse(localStorage.getItem('cam_devices'))
                  console.log('Auxiluar = ', devicesAux)
                  for (let i = 0; !band && i < devicesAux.length; i++) {
                    if (devicesAux[i].label === message.label) {
                      console.log(devicesAux[i].label, '===', message.label)
                      devicesAux[i] = Object.assign(devicesAux[i], { 'data': message.data })
                      localStorage.setItem('cam_devices', JSON.stringify(devicesAux))
                      this.$store.commit('setCamDevices', JSON.parse(localStorage.getItem('cam_devices')))
                      band = true
                    }
                  }
                  console.log(JSON.parse(localStorage.getItem('cam_devices')))
                }
              } else {
                console.log('Foto Normal')
                var aux = localStorage.getItem('listStorePhotosCamera') === null ? [] : JSON.parse(localStorage.getItem('listStorePhotosCamera'))
                while (aux.length > 0) {
                  aux.pop()
                }
                aux.push(message)
                localStorage.setItem('listStorePhotosCamera', JSON.stringify(aux))
                this.$store.commit('setPhotos', JSON.parse(localStorage.getItem('listStorePhotosCamera')))
                if (localStorage.getItem('cam_devices') !== null) {
                  console.log('Dato recivido de CAM')
                  let band = false
                  let devicesAux = JSON.parse(localStorage.getItem('cam_devices'))
                  console.log('Auxiluar = ', devicesAux)
                  for (let i = 0; !band && i < devicesAux.length; i++) {
                    if (devicesAux[i].label === message.label) {
                      console.log(devicesAux[i].label, '===', message.label)
                      devicesAux[i] = Object.assign(devicesAux[i], { 'data': message.data })
                      console.log('UNOOOOOOOOOOO')
                      // Agregar condición para filtrar por UUID de Dispositivos del Pedregal tomando como referencia el valor de devicesAux
                      let aleatorio = Math.floor(Math.random() * 30)
                      console.log('Num aleatorio =', aleatorio)
                      if (aleatorio === 10) {
                        if (devicesAux[i].uuid === 'fc01fb6a-4fc5-45ae-a6d6-6a12fbfac1d0' || devicesAux[i].uuid === 'f6177dc9-b62e-492c-9e1b-b55f3dc10e70' || devicesAux[i].uuid === '02f973c5-873e-41c0-8eb2-ccee1ecc56d7' || devicesAux[i].uuid === 'd5dbfe0b-30a7-4b7e-ab4c-e5c5f44fa0fa') {
                          this.getOCRfromImageBase64(message.data)
                        }
                      }
                      console.log('DOSSSSSSSSSS')
                      localStorage.setItem('cam_devices', JSON.stringify(devicesAux))
                      this.$store.commit('setCamDevices', JSON.parse(localStorage.getItem('cam_devices')))
                      band = true
                    }
                  }
                  console.log(JSON.parse(localStorage.getItem('cam_devices')))
                }
              }
            }
          }
          break
      }
      console.log('Dato Recivido: ', message)
    },
    getOCRfromImageBase64: async function (anImageBase64) {
      const config = {
        method: 'POST',
        url: 'https://vision.googleapis.com/v1/images:annotate?key=AIzaSyA60pFIOocMEOI_srGLb-bOMulf08bu7QY',
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          'requests': [
            {
              'image': {
                'content': anImageBase64
              },
              'features': [
                {
                  'type': 'TEXT_DETECTION'
                },
                {
                  'type': 'DOCUMENT_TEXT_DETECTION'
                }
              ]
            }
          ]
        }
      }
      axios(config)
        .then(ok => {
          console.log(ok.data.responses)
          console.log(ok.data.responses[0].fullTextAnnotation.text)
          // OCR Crudo
          let sinConvertir = ok.data.responses[0].fullTextAnnotation.text
          // OCR sin salos de línea, tabuladores
          let conConversion = sinConvertir.replace(/(\r\n|\n|\r)/gm, ' ')
          // Correccion de Texto
          conConversion = conConversion.replace('DOMIOLIO', 'DOMICILIO')
          conConversion = conConversion.replace('NOMBRIE', 'NOMBRE')
          conConversion = conConversion.replace('NOMERE', 'NOMBRE')
          // Imprimir en consola resultados para compararlos
          console.log('sinConvertir = ', sinConvertir)
          console.log('conConversion = ', conConversion)
          // let cadena = ok.data.responses[0].fullTextAnnotation.text
          if (conConversion.includes('DRIVER LICENSE')) {
            console.log('Licencia de Conducir')
            let aux = localStorage.getItem('listStorePhotosCamera') === null ? [] : JSON.parse(localStorage.getItem('listStorePhotosCamera'))
            console.log('Datos recabados 1: ', aux)
            let regularExp = /LICENSE.+?VALIDA/ig
            let resultado = regularExp.exec(conConversion)
            let cadenaRegex = resultado[0]
            // Elimnar la última palabra
            cadenaRegex = cadenaRegex.substring(0, cadenaRegex.lastIndexOf(' '))
            // Elimnar la primer palabra
            cadenaRegex = cadenaRegex.substring(cadenaRegex.indexOf(' ') + 1)
            let otro = Object.assign(aux[0], { 'fullTextAnnotation': cadenaRegex })
            let auxPhotos = []
            auxPhotos.push(otro)
            console.log('Datos recabados : ', auxPhotos)
            localStorage.setItem('listStorePhotosCamera', JSON.stringify(auxPhotos))
            this.$store.commit('setPhotos', JSON.parse(localStorage.getItem('listStorePhotosCamera')))
          } else {
            if (conConversion.includes('INSTITUTO NACIONAL ELECTORAL') || conConversion.includes('CREDENCIAL PARA')) {
              console.log('INE Credencial para Votar')
              let aux = localStorage.getItem('listStorePhotosCamera') === null ? [] : JSON.parse(localStorage.getItem('listStorePhotosCamera'))
              console.log('Datos recabados 1: ', aux)
              let regularExp = /NOMBRE.+?DOMICILIO/ig
              let resultado = regularExp.exec(conConversion)
              let cadenaRegex = resultado[0]
              // Elimnar la última palabra
              cadenaRegex = cadenaRegex.substring(0, cadenaRegex.lastIndexOf(' '))
              // Elimnar la primer palabra
              cadenaRegex = cadenaRegex.substring(cadenaRegex.indexOf(' ') + 1)
              let otro = Object.assign(aux[0], { 'fullTextAnnotation': cadenaRegex })
              let auxPhotos = []
              auxPhotos.push(otro)
              console.log('Datos recabados : ', auxPhotos)
              localStorage.setItem('listStorePhotosCamera', JSON.stringify(auxPhotos))
              this.$store.commit('setPhotos', JSON.parse(localStorage.getItem('listStorePhotosCamera')))
            } else {
              if (conConversion.includes('LICENCIA DE')) {
                console.log('Licencia de Conducir')
                let aux = localStorage.getItem('listStorePhotosCamera') === null ? [] : JSON.parse(localStorage.getItem('listStorePhotosCamera'))
                console.log('Datos recabados 1: ', aux)
                let regularExp = /ESTADO.+?SLP/ig
                let resultado = regularExp.exec(conConversion)
                let cadenaRegex = resultado[0]
                // Elimnar la última palabra
                cadenaRegex = cadenaRegex.substring(0, cadenaRegex.lastIndexOf(' '))
                // Elimnar la primer palabra
                cadenaRegex = cadenaRegex.substring(cadenaRegex.indexOf(' ') + 1)
                let otro = Object.assign(aux[0], { 'fullTextAnnotation': cadenaRegex })
                let auxPhotos = []
                auxPhotos.push(otro)
                console.log('Datos recabados : ', auxPhotos)
                localStorage.setItem('listStorePhotosCamera', JSON.stringify(auxPhotos))
                this.$store.commit('setPhotos', JSON.parse(localStorage.getItem('listStorePhotosCamera')))
              } else {
                console.log('No es INE ni Licencia de Conducir')
              }
            }
          }
        })
        .catch(error => {
          console.log(error)
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    get_current_date () {
      var today = new Date()
      var dd = today.getDate()
      var mm = today.getMonth() + 1
      var yyyy = today.getFullYear()

      if (dd < 10) {
        dd = '0' + dd
      }
      if (mm < 10) {
        mm = '0' + mm
      }
      today = mm + '/' + dd + '/' + yyyy
      return today
    },
    onError (event) {
      console.log('An error occured:', event.data)
    },
    setLocale (aLanguage) {
      localize(aLanguage)
      this.$i18n.locale = aLanguage
      this.$store.commit('changeLanguage', aLanguage)
    },
    logout () {
      localStorage.removeItem('enable_2fa')
      localStorage.removeItem('idGuardHouse')
      localStorage.removeItem('qr_code_temporal')
      localStorage.removeItem('cam_devices')
      localStorage.removeItem('qr_devices')
      localStorage.removeItem('banderaQR')
      localStorage.removeItem('banderaCam')
      localStorage.removeItem('listStoreQrCodes')
      localStorage.removeItem('listStorePhotosCamera')
      localStorage.removeItem('listStorePhotosCameraINEBack')
      localStorage.removeItem('listStorePhotosCameraAdditionalPerson')
      localStorage.removeItem('banderaAdditionalPerson')
      localStorage.removeItem('banderaINEBack')
      this.$store.commit('setQrs', [])
      this.$store.commit('setPhotos', [])
      this.$store.commit('setPhotosAdditionalPerson', [])
      this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push('/')).catch(() => this.$router.push('/')).finally(() => location.reload())
    },
    handleConnectivityChange (status) {
      console.log(status)
      this.bandOnline = status
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'getProfile', 'additionalPerson']),
    ...mapState(['otpReady']),
    hasPendingDocuments () {
      return !this.getProfile.privacy_notice_url || !this.getProfile.rulebook_url
    },
    pendingCount () {
      let count = 0
      if (!this.getProfile.rulebook_url) count++
      if (!this.getProfile.privacy_notice_url) count++
      return count
    }
  }
}
</script>

<style scoped>
    .text {
        font-size: 10;
        font-family: "Roboto", sans-serif;
        color: #ffffff;
        text-decoration:none
    }
    .text:hover {
        font-size: 10;
        font-family: "Roboto", sans-serif;
        color: #ffffff;
        text-decoration:none
    }
</style>
